<div class="flex flex-col" [class]="cardView === 'default' ? 'mt-6' : 'mt-0'">
    @if (cardView === 'default') {
    <span class="text-5xl font-bold">{{
      'home.private.employer.dashboard.area_selection' | translate
    }}</span>
    }
    <div
      class="flex mt-6 justify-between"
      [class]="cardView === 'default' ? 'flex-wrap gap-4' : 'overflow-x-auto gap-3 p-2 -mx-2'"
    >
      @for (card of cards; track card.title) {
      <app-card-selection-item
        [img]="card.img"
        [title]="card.title"
        [description]="card.description"
        [link]="card.link"
        [size]="cardView"
        (selectedRoutes)="onCardSelected($event)"
      >
      </app-card-selection-item>
      }
    </div>
  </div>